export default "__VITE_ASSET__MpsvXbWU__"